import { render, staticRenderFns } from "./editLaborer.vue?vue&type=template&id=363eeee6&scoped=true"
import script from "./editLaborer.vue?vue&type=script&lang=js"
export * from "./editLaborer.vue?vue&type=script&lang=js"
import style0 from "./editLaborer.vue?vue&type=style&index=0&id=363eeee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363eeee6",
  null
  
)

export default component.exports